import { render } from "./designSelectPrint.vue?vue&type=template&id=6d4a50f0"
import script from "./designSelectPrint.vue?vue&type=script&lang=js"
export * from "./designSelectPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__